'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isError;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isError.js
// module id = 812
// module chunks = 0